import ExternalLoginPage from "./ExternalLoginPage";

export default ExternalLoginPage;
